import { $$ } from '../../../shared/js/utils/dom';

const copyrightButtons = $$('.caption__button-copyright');

copyrightButtons &&
  copyrightButtons.forEach(button => {
    const container = button.closest('.caption');

    button.addEventListener('click', event => {
      event.stopPropagation();
      const buttonTarget = event.currentTarget;
      const isExpanded = buttonTarget.getAttribute('aria-expanded') === 'true';

      buttonTarget.setAttribute('aria-expanded', !isExpanded);
      container.classList.toggle('is-open');
    });
  });
